module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [(_vm.flex !== undefined) ? _c('div', [(!_vm.editable) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Tecnología",
      "disabled": !_vm.editable
    },
    model: {
      value: (_vm.flex.tecnology),
      callback: function($$v) {
        _vm.$set(_vm.flex, "tecnology", $$v)
      },
      expression: "flex.tecnology"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editable) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('drop-down', {
    attrs: {
      "title": _vm.ddTitleTec
    }
  }, [_c('a', {
    staticClass: "dropdown-togGLe",
    attrs: {
      "slot": "title",
      "data-togGLe": "dropdown"
    },
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.ddTitleTec))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_more")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.putTec('GPS')
      }
    }
  }, [_vm._v("GPS")])])])], 1)]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input-validate', {
    attrs: {
      "type": "text",
      "validations": "required|regex:^([0-9A-Za-z]+)$",
      "name": "numero de serie",
      "label": "Número de Serie",
      "delay": "0",
      "disabled": !_vm.editable,
      "value": _vm.gps.serial_number
    },
    on: {
      "input-changed": _vm.input_changed
    },
    model: {
      value: (_vm.gps.serial_number),
      callback: function($$v) {
        _vm.$set(_vm.gps, "serial_number", $$v)
      },
      expression: "gps.serial_number"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input-validate', {
    attrs: {
      "type": "text",
      "validations": "required|regex:^([0-9A-Za-z]+)$",
      "name": "template",
      "label": "Template",
      "delay": "0",
      "disabled": !_vm.editable,
      "value": _vm.gps.template
    },
    on: {
      "input-changed": _vm.input_changed
    },
    model: {
      value: (_vm.gps.template),
      callback: function($$v) {
        _vm.$set(_vm.gps, "template", $$v)
      },
      expression: "gps.template"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(!_vm.editable) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Marca",
      "disabled": !_vm.editable
    },
    model: {
      value: (_vm.gps.make),
      callback: function($$v) {
        _vm.$set(_vm.gps, "make", $$v)
      },
      expression: "gps.make"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editable) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('drop-down', {
    attrs: {
      "title": _vm.ddTitleMake
    }
  }, [_c('a', {
    staticClass: "dropdown-togGLe",
    attrs: {
      "slot": "title",
      "data-togGLe": "dropdown"
    },
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.ddTitleMake))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_more")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.putMake('Queclink');
        _vm.updateModel('queclink')
      }
    }
  }, [_vm._v("Queclink")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.putMake('Calamp');
        _vm.updateModel('calamp')
      }
    }
  }, [_vm._v("Calamp")])])])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.editable) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Modelo",
      "disabled": !_vm.editable
    },
    model: {
      value: (_vm.gps.model),
      callback: function($$v) {
        _vm.$set(_vm.gps, "model", $$v)
      },
      expression: "gps.model"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editable) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('drop-down', {
    attrs: {
      "title": _vm.ddTitleModel
    }
  }, [_c('a', {
    staticClass: "dropdown-togGLe",
    attrs: {
      "slot": "title",
      "data-togGLe": "dropdown"
    },
    slot: "title"
  }, [_c('span', [_vm._v(_vm._s(_vm.ddTitleModel))]), _vm._v(" "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_more")])]), _vm._v(" "), _vm._l((_vm.queclinkModels), function(model) {
    return (_vm.ddTitleMake === 'Queclink') ? _c('li', {
      key: model.id
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.putModel(model)
        }
      }
    }, [_vm._v(_vm._s(model))])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.calampModels), function(model) {
    return (_vm.ddTitleMake === 'Calamp') ? _c('li', {
      key: model.id
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.putModel(model)
        }
      }
    }, [_vm._v(_vm._s(model))])]) : _vm._e()
  })], 2)], 1)]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7d764d21!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Products/GPSForm.vue
// module id = 251
// module chunks = 3